// extracted by mini-css-extract-plugin
export var clock = "TopBar-module--clock--NEm3Q";
export var date = "TopBar-module--date--Mr7Kk";
export var logo = "TopBar-module--logo--WgxgP";
export var longDate = "TopBar-module--longDate--fmzqc";
export var outer = "TopBar-module--outer--uCMyL";
export var root = "TopBar-module--root--T+YY-";
export var shortDate = "TopBar-module--shortDate--ue3Vt";